import { Avatar } from '@seek/avatar';
import { useTranslations } from '@vocab/react';
import { Box, CheckboxStandalone } from 'braid-design-system';
import type { FC } from 'react';

import translations from '../.vocab';
import type { JobApplicationCardProps } from '../JobApplicationCard';

import * as styles from './AvatarCheckbox.css';

export const AvatarCheckbox: FC<
  Pick<JobApplicationCardProps, 'jobApplication' | 'checkboxProps'>
> = ({ jobApplication, checkboxProps }) => {
  const { t } = useTranslations(translations);

  return (
    <Box className={styles.hoverContainer} onClick={(e) => e.stopPropagation()}>
      <Box
        id={`avatar-${jobApplication.id}`}
        display={checkboxProps.checked ? 'none' : 'block'}
        className={`displayAvatar ${styles.hoverToggleDisplay}`}
      >
        <Avatar
          name={jobApplication.fullName}
          variant="initials"
          size="large"
        />
      </Box>
      <Box
        display={checkboxProps.checked ? 'block' : 'none'}
        className={`displayCheckbox ${styles.hoverToggleDisplay}`}
      >
        <CheckboxStandalone
          id={`checkbox-${jobApplication.id}`}
          size="small"
          aria-label={t('Select candidate fullName', {
            fullName: jobApplication.fullName,
          })}
          checked={checkboxProps.checked}
          onChange={checkboxProps.onChange}
        />
      </Box>
    </Box>
  );
};
